module.exports = __webpack_public_path__ + "static/img/6816_phase_function_Paper_PointsHejduk_Prediction.f76a688.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6816_phase_function_Paper_PointsHejduk_Prediction.png
// module id = ASh9
// module chunks = 0